export default __webpack_public_path__ + "static/media/oval.ad15188b.svg";